/* The sign-in screen. OWNED BY ITEM 6 OF docs/plan/00-prestavba-2026-08.md. */

import { useState } from "react";
import { api, ApiError, type Me } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

export function SignIn({ onSignedIn }: { onSignedIn: (me: Me) => void }) {
  const { ui } = useI18n();
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    setBusy(true);
    setMsg("");
    try {
      onSignedIn(await api<Me>("/auth/login", {
        method: "POST",
        body: JSON.stringify({
          username: String(form.get("username") ?? ""),
          password: String(form.get("password") ?? ""),
        }),
      }));
    } catch (err) {
      /* The server's own sentence, not a generic one. After too many attempts
         it says how long to wait, and that is the only useful thing to say. */
      setMsg(err instanceof ApiError ? err.message : ui("admin.badLogin"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="catalog adm">
      <header className="cat-hero">
        <div className="eyebrow">{ui("admin.eyebrow")}</div>
        <h1>{ui("admin.title")}</h1>
        <p className="lead">{ui("admin.signInLead")}</p>
      </header>
      <form className="adm-gate" onSubmit={(e) => void submit(e)}>
        <label className="adm-field">
          {ui("admin.username")}
          <input name="username" autoComplete="username" autoFocus required />
        </label>
        <label className="adm-field">
          {ui("admin.password")}
          <input name="password" type="password" autoComplete="current-password" required />
        </label>
        <button type="submit" disabled={busy}>
          {busy ? ui("admin.signingIn") : ui("admin.signIn")}
        </button>
        {msg ? <p className="adm-msg bad">{msg}</p> : null}
      </form>
    </div>
  );
}
